<ng-template #content>
    <div class="w-100">
        <ng-content></ng-content>
    </div>
</ng-template>
